export const blogPosts = [
  {
    slug: "qu-est-ce-que-le-rag-guide-pme",
    title: "Qu'est-ce que le RAG ? Guide complet pour les PME françaises",
    date: "2026-04-15",
    author: "Valentin Fiess",
    excerpt: "Découvrez comment la Retrieval-Augmented Generation (RAG) permet à une IA de répondre en utilisant exclusivement vos documents internes en toute sécurité.",
    image: "/blog/rag-guide.webp",
    tags: ["Guide RAG", "PME", "IA Documentaire"],
    readTime: "8 min"
  },
  {
    slug: "choisir-assistant-ia-documentaire-pme",
    title: "Comment choisir un assistant IA documentaire pour votre PME : le guide complet 2026",
    date: "2026-04-18",
    author: "Valentin Fiess",
    excerpt: "Sécurité, RGPD, facilité de prise en main, prix… Tous les critères pour choisir un assistant IA qui lit et répond à partir de vos documents internes, sans se tromper de fournisseur.",
    image: "/blog/assistant-ia-documentaire.webp",
    tags: ["assistant IA", "PME", "RGPD", "RAG", "documents internes", "chatbot entreprise"],
    readTime: "10 min"
  },
  {
    slug: "cas-usage-rag-pme-francaises",
    title: "5 cas d'usage concrets du RAG pour les PME françaises",
    date: "2026-05-17",
    author: "Valentin Fiess",
    excerpt: "RH, juridique, SAV, commercial, IT : découvrez cinq cas réels où un assistant IA connecté à vos documents internes change la façon de travailler.",
    image: "/blog/cas-usage-rag.webp",
    tags: ["cas d'usage", "RAG", "PME", "IA documentaire", "RH", "juridique", "SAV", "commercial", "IT"],
    readTime: "6 min"
  }
];
